<template>
  <div class="content blacklist">
    <el-form ref="form" :model="form" label-width="160px">
      <div class="box">
        <div class="title">
          基本信息
        </div>
        <el-form-item label="活动名称" class="fixedWidth">
          <el-input v-model="form.name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <div>
            <el-radio-group v-model="form.resource">
              <el-radio label="永久有效 "></el-radio>
              <el-radio label="活动截止年份"></el-radio>
            </el-radio-group>
          </div>
          <div class="flex">
            <el-date-picker
              size="small"
              v-model="value3"
              type="year"
              placeholder="选择年">
            </el-date-picker>
            <div class="color">
              生日范围规则，在活动截止当年仍然有效
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          参与规则
        </div>
        <el-form-item label="生日范围">
          <el-date-picker
            size="small"
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="参与对象">
          <el-radio-group v-model="form.resource">
            <el-radio label="所有客户 "></el-radio>
            <el-radio label="所有粉丝"></el-radio>
            <el-radio label="会员"></el-radio>
            <el-radio label="按用户标签"></el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="box">
        <div class="title">
          活动奖品
        </div>
        <el-form-item label="生日范围">
          <el-date-picker
            size="small"
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="参与对象">
          <el-radio-group v-model="form.resource">
            <el-radio label="所有客户 "></el-radio>
            <el-radio label="所有粉丝"></el-radio>
            <el-radio label="会员"></el-radio>
            <el-radio label="按用户标签"></el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <!-- 底部提交 -->
    <div class="bottom">
      <el-button>取消</el-button>
      <el-button type="primary">确定</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      radio: "0",
      value: "0",
      imageUrl: '',
      setServel: "0",
      checkList: ['0',"1"],
      manualShow: false,
      form: {
        name: "",
      }
    };
  },
  mounted() {

  },
  methods: {
    // 提现方式
    checkMethods(value){
      console.log("值更新", value);
      var arr = value;
      this.manualShow = value.some(item =>{return item =='2'});
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 20px 60px 20px;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  background: #f2f2f6;
  font-size: 14px;
  overflow: scroll;
  position: relative;
  .box{
    background: #fff;
    margin-top: 20px;
    padding: 10px 0px;
    .title{
      font-weight: 550;
      padding: 10px 0px 10px 20px;
    }
    // 样式
    .textAlign{
      text-align: right;
    }
    .color{
      margin: 0px 5px;
      color: #999;
      font-size: 12px;
    }
    .inputMargin{
      margin: 0 6px;
    }
    .inputWidth{
      height: 30px;
      width: 130px;
    }
    
  }
  // 表格
  .table{
    max-width: 600px;
    padding: 10px 5px;
    background: #f2f2f6;
    height: 100%;
    >div{
      padding: 10px;
    }
    .name{
      font-weight: 550;
      padding: none;
    }
    .table-left{
      width: 200px;
      
      border-right: 1px solid #fff;
    }
    .table-right{
      flex: 1;
    }
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .fixedWidth{
      width: 500px;
      .line{
        text-align: center
      }
    }
  // 底部
  .bottom{
    position: fixed;
    bottom : 0;
    border-top : 1px solid #f2f2f6;
    height: 60px;
    line-height: 60px;
    background: #fff;
    text-align: center;
    width: 100%;
    padding: 0 20px;
  }
}

</style>